module.exports = __webpack_public_path__ + "img/logo.23e90515.png";